import { TabPanel, TabPanelProps } from '@mui/lab';
import { cn } from '@nexelem/utils';

export const DrawerPanel = ({ className, ...props }: TabPanelProps) => (
  <TabPanel {...props} className={cn('flex grow flex-col overflow-hidden p-0 empty:hidden', className)} />
);
